import React from "react";
import { Select, Text } from "@chakra-ui/react";
import { ElementsApi } from "@radianse/services";
import PropTypes from "prop-types";
import { useQuery } from "react-query";

import ErrorMsg from "../Error";
import Loader from "../Loader";

const getAllElementTypes = (array, level) => {
  level = ++level || 0;
  let spacing = Array(level).join("\u00A0\u00A0");
  let result = [];
  let startArr = !level ? array : array;
  startArr.forEach(({ item, children = [] }) => {
    const temp = getAllElementTypes(children, level);
    if (temp.length) {
      return (result = result.concat(
        [{ label: spacing + item.name, value: item.id }],
        temp
      )); //item.name + ', ' + temp;
    }
    return (result = result.concat([
      { label: spacing + item.name, value: item.id },
    ]));
  });
  return result;
};

const ElementTreeSelect = ({
  initialValue,
  handleElementTreeChange,
  value,
  variant,
}) => {
  const { data, error, isError, isLoading } = useQuery({
    queryKey: ["ElementTree"],
    queryFn: () => ElementsApi().getElementTree(),
    select: (response) => {
      const equipmentElements = response?.data
        ?.find((e) => e.item.id === "thing")
        ?.children?.find((e) => e.item.id === "Equipment")?.children;

      return getAllElementTypes(equipmentElements);
    },
  });

  // If there is an error, display it
  if (isError) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.message ||
      "Unknown error occurred";

    return <ErrorMsg message={`Failed Request: ${errorMessage}`} />;
  }

  // If the query is still fetching show a loading indicator
  if (isLoading) {
    return <Loader text="Getting Element Tree..." />;
  }

  return (
    <Select
      data-testid="element-tree-select"
      defaultValue={initialValue}
      onChange={handleElementTreeChange}
      placeholder="Select Type"
      value={value}
      variant={variant}
      style={{ textOverflow: "ellipsis" }}
    >
      <option value={""}>All Types</option>
      {data?.map(({ label, value }) => (
        <option value={value} key={`${label}_${value}`}>
          {label}
        </option>
      ))}
    </Select>
  );
};

ElementTreeSelect.propTypes = {
  initialValue: PropTypes.string,
  handleElementTreeChange: PropTypes.func,
  value: PropTypes.string,
  variant: PropTypes.string,
};

export default ElementTreeSelect;
